// extracted by mini-css-extract-plugin
export default {"container":"BrandsAccounts_container__C56-h"};